/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ScheduleItem } from '../../models/schedule-item';
import { ScheduleUpdateDto } from '../../models/schedule-update-dto';

export interface ScheduleControllerUpdateSchedule$Params {
  id: number;
      body: ScheduleUpdateDto
}

export function scheduleControllerUpdateSchedule(http: HttpClient, rootUrl: string, params: ScheduleControllerUpdateSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ScheduleItem;
}>> {
  const rb = new RequestBuilder(rootUrl, scheduleControllerUpdateSchedule.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ScheduleItem;
      }>;
    })
  );
}

scheduleControllerUpdateSchedule.PATH = '/schedule/{id}';
